import { defineMessages, IntlShape } from "react-intl";

import PinLegendDatingMethod from "@mapmycustomers/shared/enum/pinLegends/PinLegendDatingMethod";

const messages = defineMessages<PinLegendDatingMethod>({
  [PinLegendDatingMethod.ABSOLUTE]: {
    id: "pinLegendDatingMethod.absolute",
    defaultMessage: "Absolute",
  },
  [PinLegendDatingMethod.ORDINAL]: {
    id: "pinLegendDatingMethod.ordinal",
    defaultMessage: "Ordinal",
  },
  [PinLegendDatingMethod.RELATIVE]: {
    id: "pinLegendDatingMethod.relative",
    defaultMessage: "Relative",
  },
});

const getPinLegendDatingMethodDisplayName = (
  intl: IntlShape,
  datingMethod: PinLegendDatingMethod
) => intl.formatMessage(messages[datingMethod]);

export default getPinLegendDatingMethodDisplayName;
